<template>
  <span>
    <b-btn size="sm" @click.prevent="onClick" class="vgt-left-btn">
      Upload File
      <svg width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-paperclip" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" d="M4.5 3a2.5 2.5 0 0 1 5 0v9a1.5 1.5 0 0 1-3 0V5a.5.5 0 0 1 1 0v7a.5.5 0 0 0 1 0V3a1.5 1.5 0 1 0-3 0v9a2.5 2.5 0 0 0 5 0V5a.5.5 0 0 1 1 0v7a3.5 3.5 0 1 1-7 0V3z"/>
      </svg>
    </b-btn>
    <input type="file" ref="fileInput" @change="onFileChanged" class="d-none" accept=".csv, .xlsx">

    <b-modal ref="modal" size="xlg" lazy @hide-footer="true" :title="title" @hide="onHide">
      <div class="import--container">
        <div class="row">
          <div class="col-sm-12">
            <Alerts/>
            <LoadingSpinner v-if="isLoading"/>

            <div v-if="view === 'mapping'">
              <b-row>
                <b-col cols="8">
                  <table class="table mapping-table">
                    <thead>
                      <tr>
                        <th>Your File's Column Headers</th>
                        <th width="100"></th>
                        <th>GrandShipper Fields</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(header, i) in headers" :key="i">
                        <td class="text-right">{{header}}</td>
                        <td>=</td>
                        <td>
                          <b-select
                            :options="field_options"
                            v-model="field_map[i]"
                            @change="onFieldSelect(i)"
                            size="lg"
                            class="d-block w-100">
                          </b-select>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </b-col>
                <b-col>
                  <label-preview :label="label_preview" style="max-width: 350px"></label-preview>
                </b-col>
              </b-row>
            </div>
          </div>
        </div>
      </div>

      <div slot="modal-footer">
        <div v-if="!isDone">
          <b-button type="submit" variant="primary" size="lg" @click="onSubmit">Import Orders</b-button>
        </div>
      </div>
    </b-modal>
  </span>
</template>
<style lang="scss" scoped>
.mapping-table {
  font-size: 18px;
}
</style>

<script>
import Papa from "papaparse";
import numeral from "numeral";
import XLSX from "xlsx";
import LoadingSpinner from "./LoadingSpinner";
import Alerts from "./Alerts";

function urltoFile(url) {
  return fetch(url)
    .then(res => res.blob())
    .then(blob => {
      console.log("blob", blob);
      return new File([blob], "File name");
    });
}

export default {
  components: {
    LoadingSpinner,
    Alerts
  },
  props: {
    orderStatusId: Number // order status to query
  },
  data() {
    return {
      isLoading: false,
      view: "mapping",
      isDone: false,
      file: null,
      deselected: [],
      rows: [],
      field_map: [],
      cols: {
        // marketplace: "Marketplace",
        order_number: "Order #",
        order_date: "Order Date",
        decalared_value: "Declared Value",
        total: "Total",
        // buyer: "Buyer Name",
        company: "Company",
        first_name: "First Name",
        last_name: "Last Name",
        address: "Address 1",
        address2: "Address 2",
        city: "City",
        state: "State/Province",
        country: "Country",
        postal_code: "Postal Code",
        phone: "Phone #",
        email: "Email",
        service: "Service Type",
        package_type: "Package Type",
        weight_lb: "Weight (lb)",
        weight_oz: "Weight (oz)",
        length: "Length (in)",
        width: "Width (in)",
        height: "Height (in)",
        label_sticky: "Custom Field 1",
        label_sticky_2: "Custom Field 2",
        // insurance: "Insurance",
        // signature: "Signature",
      }
    };
  },
  computed: {
    title() {
      if(this.view === 'mapping') {
        return 'Confirm Field Mapping'
      }
      return 'Import Orders';
    },
    num_columns() {
      if (this.rows[0]) {
        return this.rows[0].length;
      }
      return 0;
    },
    headers() {
      if (this.rows[0]) {
        // console.log('headers', this.rows[0]);
        this.field_map = this.rows[0].map(v => {
            const field = _.findKey(this.cols, function(f) {
              const vv = v.toLowerCase().trim();
              const ff = f.toLowerCase().trim();
              if(ff === "state/province" && (vv === "state" || vv === "province" || vv === "state/province")) {
                return true;
              }else if(ff === "package type" && vv === "package") {
                return true;
              }else if(ff === "service type" && vv === "service") {
                return true;
              }else if(ff === "length (in)" && vv === "length") {
                return true;
              }else if(ff === "width (in)" && vv === "width") {
                return true;
              }else if(ff === "height (in)" && vv === "height") {
                return true;
              }else if(ff === "weight (lb)" && vv === "weight (lbs)") {
                return true;
              }else if(ff === "phone #" && vv === "phone number") {
                return true;
              }else{
                return ff === vv
              }
            });
            return field? field : null;
        });
        return this.rows[0];
      }
      return [];
    },
    field_options() {
      let options = _.map(this.cols, (text, value) => {
        return {
          value,
          text
        };
      });

      console.log('field options', options);

      return [
        {
          value: null,
          text: "-- Ignore --"
        },
        ...options
      ];
    },
    tableFields() {
      let fields = [{ key: "index", label: "Deselect" }];

      for (var i = 0; i < this.num_columns; i++) {
        fields.push({
          key: i.toString(),
          label: ""
        });
      }

      return fields;

      for (var i = 0; i < this.cols.length; i++) {
        const label = this.cols[i];

        let obj = {
          key: i.toString(),
          label: label
        };

        if (label in ["Total"]) {
          obj.formatter = cell => {
            return numeral(cell).format("$0,0.00");
          };
        }

        fields.push(obj);
      }

      return fields;
    },
    label_preview() {
      if(!this.rows[1]) {
        return {}
      }

      let map = _.invert(this.field_map)
      return {
        name: this.rows[1][map.buyer] || null,
        first_name: this.rows[1][map.first_name] || null,
        last_name: this.rows[1][map.last_name] || null,
        company: this.rows[1][map.company] || null,
        address: this.rows[1][map.address] || null,
        address2: this.rows[1][map.address2] || null,
        city: this.rows[1][map.city] || null,
        state: this.rows[1][map.state] || null,
        postal_code: this.rows[1][map.postal_code] || null,
        country: this.rows[1][map.country] || null,
        label_sticky: this.rows[1][map.label_sticky] || null,
        label_sticky_2: this.rows[1][map.label_sticky_2] || null,
      }
    }
  },
  mounted() {
    console.log("import");
    this.field_map = Cookies.getJSON(`import-fieldmap`) || {};
  },
  methods: {
    onFieldSelect(i){
      return function(val){
        this.field_map = _.map(this.field_map, (field, index) => {
          if(field === val && index != i) {
            field = null;
          }
          return field;
        })
      }
    },
    onClick() {
    this.$refs.fileInput.value = null;
    this.$refs.fileInput.click();
      //this.show();
    },

    show() {
      this.$refs.modal.show();
    },

    hide() {
      this.$refs.modal.hide();
    },

    onHide() {},

    readFileAsync(file) {
      return new Promise((resolve, reject) => {
        let reader = new FileReader();

        reader.onload = () => {
          resolve(reader.result);
        };

        reader.onerror = reject;

        reader.readAsBinaryString(file);
      });
    },

    async onFileChanged(e) {
      this.isLoading = true;
      this.view = "mapping";
      this.rows = [];
      this.$emit("alert_close");

      let file = e.target.files[0];

      let content = null;
      let type = null;

      if (/\.csv$/i.test(file.name)) {
        type = "csv";
      } else if (/\.xlsx$/i.test(file.name)) {
        type = "xlsx";
      } else {
        this.$parent.$emit("alert", {
          message: "Invalid format. Please provide a CSV or XLS file.",
          type: "danger"
        });
        this.isLoading = false;
        return;
      }

      try {
        content = await this.readFileAsync(file);
      } catch (e) {
        this.$parent.$emit("alert", {
          message: "Failed to read file",
          type: "danger"
        });
        this.isLoading = false;
        return;
      }

      if (type === "xlsx") {
        const workbook = XLSX.read(content, { type: "binary" });
        const sheetName = workbook.SheetNames[0];
        const sheet = workbook.Sheets[sheetName];
        content = XLSX.utils.sheet_to_csv(sheet);
      }

      const result = Papa.parse(content);

      result.data = _.filter(result.data, row => {
        let valid = true;

        if (!row.join("")) {
          return false;
        }

        return valid;
      });

      // empty
      if (!result.data.length) {
        this.$parent.$emit("alert", {
          message: "Invalid file: no rows present",
          type: "danger"
        });
        this.isLoading = false;
        return;
      }

      /*
      if (result.data[0].length !== this.getNumFields()) {
        this.$parent.$emit("alert", {
          message:
            "Invalid file: the number of columns should be " +
            this.getNumFields() +
            " exactly.<br>" +
            "<a href='/storage/import-example.csv'><u>Download template</u></a>",
          type: "danger"
        });
        this.isLoading = false;
        return;
      }
      */

      this.rows = result.data;
      this.show();
      this.isLoading = false;
    },

    onSubmit(e) {
      e.preventDefault();

      this.isLoading = true;

      const selectedRows = this.rows.filter(
        (row, key) => !this.deselected.includes(key)
      );

      Cookies.set(`import-fieldmap`, this.field_map, { expires: 30 });

      axios
        .post("/orders/import", {
          rows: selectedRows,
          field_map: this.field_map,
          order_status_id: this.orderStatusId
        })
        .then(response => {
          this.$emit('imported')
          this.$refs.modal.hide();

          // setTimeout(() => {
          //   this.$destroy();
          // }, 1000);
        })
        .catch(error => {
          this.$parent.$emit("alert", {
            message: error.response.data.message,
            type: "danger"
          });
        })
        .finally(() => {
          this.restart();
          this.isLoading = false;
        });
    },

    restart() {
      this.isLoading = false;

      this.isDone = false;
      this.file = null;
      this.rows = [];
    },

    onDeselect(val) {
      console.log('desecetec', val);
    },

    getNumFields() {
      return this.tableFields.length - 1;
    }
  },
  watch: {
    deselected: function(newVal, oldVal) {
      this.rows = this.rows.map((row, key) => {
        row._rowVariant = newVal.includes(key) ? "danger" : "";
        return row;
      });
    }
  }
};
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/ImportButton.vue